import { render, staticRenderFns } from "./PZD801Result.vue?vue&type=template&id=0909796e&"
import script from "./PZD801Result.vue?vue&type=script&lang=js&"
export * from "./PZD801Result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports